// This is the application allow the user to send email to owner.
// Icon imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

// Libaries imports
import {useState} from "react";
import emailjs from "emailjs-com"
import { toast } from "react-toastify";

export default function EmailForm() {

    /* -------- Variables ------*/
    // Create form to handle name, email and message
    const [form, setForm] = useState({
        name: "",
        email: "",
        message: ""
        });
    const [loading, setLoading] = useState(false);
    
    /* -------- Env variables ------*/
    const service_id = process.env.REACT_APP_SERVICE_ID
    const template_id = process.env.REACT_APP_TEMPLATE_ID
    const public_key = process.env.REACT_APP_PUBLIC_KEY
    
    /* -------- Functions ------*/
    // Handle to check all changes in the form
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        };
    
    
    // Handle to send email with name, email and message.
    const sendEmail = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await emailjs.send(
            service_id,
            template_id,
            {
                form_name: form.name,
                form_email: form.email,
                message:form.message,
            },
            public_key
            );

            toast.success("Email sent successfully!");
            setForm({ name: "", email: "", message: "" });
        } catch (err) {
            alert("Failed to send email");
        }

        setLoading(false);
    };
    
    return(
        <form onSubmit={sendEmail} >
            <div className="contact-container">
                <div className="two-column-layout-contact">
                <div className="input-contact">
                    <label className="label-contact"> Name </label>
                    <input placeholder="Name" name="name" type="text" value={form.name} onChange={handleChange}></input>
                </div>
                <div className="input-contact">
                    <label className="label-contact"> Email </label>
                    <input placeholder="Enter your email" name="email" type="email" value={form.email} onChange={handleChange}></input>
                </div>
                </div>
                <div className="textarea-container">
                <div className="input-contact">
                    <label className="label-contact"> Message </label>
                    <textarea placeholder="Your message" name="message" type="text" value={form.message} onChange={handleChange}></textarea>
                </div>
                <button type="submit" className="submit-button"> {loading ? 
                    (<div className="submit-loading">
                    Sending... <AiOutlineLoading3Quarters disabled={loading} className="animate-spin"/>
                    </div>) : 
                    (<div>
                    Send <FontAwesomeIcon icon={faArrowRight}/> 
                    </div>) } </button>
                </div>
            </div>
        </form>
    )
}